<div class="whats-new-container" *ngIf="showImg">
  <!-- <bh-avatar  
    size="small"
    [image]="getAvatarUrl()"
    firstname=""
    lastname=""
    (click)="onClickWhatsnewDialog()"
  >
  </bh-avatar> -->  
<span class="whats-new-icon" (click)="onClickWhatsnewDialog()">
  <bh-icon [icon]="data?.icon" size="medium" color="primary"></bh-icon>
</span>

</div>




